module.exports = __webpack_public_path__ + "static/media/user.84a093da.svg";